module.exports = __webpack_public_path__ + "img/18.0421b8b2.png";